import React, { useEffect, useState } from "react";
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Typography,
  Space,
  Card,
  Grid,
} from "antd";
// import "antd/dist/antd.css";
import "./customStyle.css";
import CryptoJS from "crypto-js";
import { useDispatch } from "react-redux";
import { watchGetUserDetails } from "../../Store/Buzzcom/saga";
import { getUserDetail } from "../../Store/Buzzcom/actions";
import generateDeviceId from "./utils/generateDeviceId";
import apiServices from "../../services/apiServices";

import Navbar from "../../component/Navbar";
import HeroSection from "./../HeroSection";
import Capabilities from "./../Capibilities";
import SellingProduct from "./../SellingProduct";
import FaceToFace from "./../FaceToFace";
import Instruction from "./../Instruction";
import LastSection from "./../LastSection";
import { useHistory } from "react-router-dom";

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;
const decryptUrl = (encryptedUrl) => {
  return CryptoJS.AES.decrypt(encryptedUrl, "9GxbhX0FNMP").toString(
    CryptoJS.enc.Utf8
  );
};

function BuzzcomHome() {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    const handleRedirect = async () => {
      const params = new URLSearchParams(window.location.search);
      const encryptedData = params.get("encryptedData");

      if (encryptedData) {
        try {
          const decodedRedirectInfo = JSON.parse(
            decodeURIComponent(encryptedData)
          );
          const token = decryptUrl(decodedRedirectInfo.token);
          const userId = decryptUrl(decodedRedirectInfo.userId);
          const user = decryptUrl(decodedRedirectInfo.user);
          const refreshToken = decryptUrl(decodedRedirectInfo.jwtRefreshToken);

          console.log("SIGNIN>>>INFO", token, userId, user, refreshToken);

          // Save data to localStorage
          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("user", user);
          localStorage.setItem("userId", userId);

          // Generate device ID and register platform
          const deviceId = await generateDeviceId();
          if (deviceId) {
            const apiPayload = {
              platform: "web",
              userId: JSON.parse(user).id.toString(),
              signIn: true,
              deviceId,
            };

            const registerPlatformResponse =
              await apiServices.updateUserPlatform(apiPayload);
            console.log(
              "REGISTER_PLATFORM_RESPONSE??",
              registerPlatformResponse
            );
          }

          // Dispatch Redux action to get user details
          const payload = { id: userId };
          dispatch(getUserDetail(payload));

          // Redirect if token and user are valid
        } catch (error) {
          console.error("Error decrypting URL:", error);
        }
      }
    };

    handleRedirect();
    // setLoading(false);
  }, []);
  const handleBuzzcomClick = () => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");

    if (token && user) {
      // Redirect to Buzzcom if token and user exist
      window.location.href = "/buzzcom";
    } else {
      // Redirect to the signup/signin module
      handleAuthClick();
    }
  };

  // const handleAuthClick = () => {
  //   window.location.href = "https://signup-domain.com/signup";
  // };

  const encryptURL = (currentURL) => {
    return CryptoJS.AES.encrypt(currentURL, "secret_key").toString();
  };

  const handleAuthClick = () => {
    const currentURL = window.location.href;
    const encryptedURL = encryptURL(currentURL);
    const redirectObject = {
      platformId: 1,
      encryptedURL: encryptedURL,
      targetURL: process.env.REACT_APP_REDIRECTION_URL, // Access environment variable directly
    };
    const redirectURL = `${
      process.env.REACT_APP_REDIRECTION_URL
    }?redirectInfo=${encodeURIComponent(JSON.stringify(redirectObject))}`;
    // Perform redirection
    console.log("red<<", redirectURL);
    window.location.href = redirectURL;
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setIsShow(true);
      push("/buzzcom");
    }
  }, [localStorage.getItem("token")]);

  return (
    <>
      {!isShow ? (
      <div style={{
        // overflowY:"hidden"
      }}>
          <Navbar handleAuthClick={handleAuthClick} />
          <HeroSection handleAuthClick={handleAuthClick} />
          <Capabilities />
          <SellingProduct />
          <FaceToFace />
          <Instruction />
          <LastSection />
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default BuzzcomHome;
